import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const ASSIGN_USER_TO_MENU_CURATION_TASK_MUTATION = gql`
  mutation assignUserToMenuCurationTask(
    $id: ID!
    $userId: ID
    $actionType: UserAssignmentActionType!
  ) {
    assignUserToMenuCurationTask(
      id: $id
      userId: $userId
      actionType: $actionType
    ) {
      id
      taskStatus
      tierOneCuratorAssignedAt
      unknownWordsCuratorAssignedAt
      unknownWordsQaAssignedAt
      curatorAssignedAt
      lastManualUpdateAt
      qaAssignedAt
      qcAssignedAt
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc

      assignedTierOneCurator {
        ...SimpleUserFragment
      }

      assignedCurator {
        ...SimpleUserFragment
      }

      assignedQa {
        ...SimpleUserFragment
      }

      assignedUnknownWordsCurator {
        ...SimpleUserFragment
      }

      assignedUnknownWordsQa {
        ...SimpleUserFragment
      }

      assignedQc {
        ...SimpleUserFragment
      }

      assignedScrapingReviewerUser {
        ...SimpleUserFragment
      }

      lastManualUpdateBy {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default ASSIGN_USER_TO_MENU_CURATION_TASK_MUTATION
